import StatusCell from '../../../components/Badge/StatusCell';
import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import CustomerLinkCell from '../../../components/Table/TableAccessories/CustomerLinkCell';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';
import TableMoneyFormatter from '../../../components/Table/TableAccessories/TableMoneyFormatter';
import { capitalize } from '../../../utils/utils';
import TransactionDetailSlider from './TransactionDetailSlider';
import TransactionFiltersBar from './TransactionFiltersBar';

const Transactions = () => {
  return (
    <Page title='Hethera | Transactions'>
      <PageLayout>
        <PageHeader title='Transactions' className='no-bottom-padding' />

        <Table
          tableHeader={{
            Reference: 'reference',
            Customer: 'chat_id',
            Category: 'type',
            Provider: 'provider',
            Amount: 'amount',
            Source: 'source',
            Status: 'status',
            Date: 'created_at',
          }}
          tableDataSourceUrl='api/v1/admin/transactions'
          size={20}
          border
          tableFilterBoxFeatures={{
            showSearchBox: true,
            searchBoxPlaceholder: 'Reference, phone, provider ref, or gift/Ejor code',
            rightAttr: [{ type: 'custom-filter', comp: <TransactionFiltersBar /> }],
          }}
          cellsCustomComp={{
            chat_id: <CustomerLinkCell />,
            type: <TypeCell dataKey='type' />,
            amount: <TableMoneyFormatter dataKey='amount' />,
            source: <SourceCell />,
            status: <StatusCell statusKey='status' hasDot positiveType />,
            created_at: <TableDateTimeFormatter dataKey='created_at' />,
          }}
          clickRowShowSliderComp={(row) => <TransactionDetailSlider data={row} />}
          hasClickableRow
          emptyStateMsg='No transactions found'
        />
      </PageLayout>
    </Page>
  );
};

export default Transactions;

const TypeCell: React.FC<{ data?: Record<string, any>; dataKey?: string }> = ({
  data,
  dataKey,
}) => {
  const value = data && dataKey ? data[dataKey] : undefined;
  if (value === 'GIFT') return <>Dash gift</>;
  return <>{value ? capitalize(String(value).replace('_', ' ')) : 'N/A'}</>;
};

// "Scheduled · SC-xxxx", plus the Ejor code when someone else paid. Gift rows
// say which half of the gift they are, so a delivery doesn't pass for an
// ordinary purchase.
const SourceCell: React.FC<{ data?: Record<string, any> }> = ({ data }) => {
  if (!data) return <>N/A</>;
  if (data.gift_code) {
    return (
      <>
        {data.gift_role === 'charge' ? 'Gift payment' : 'Gift delivery'} · {data.gift_code}
      </>
    );
  }
  const source = data.schedule_code ? `${data.source} · ${data.schedule_code}` : data.source;
  return <>{data.ejor_code ? `${source} · Ejor ${data.ejor_code}` : source ?? 'N/A'}</>;
};
